import permissions from "./permissions";
import HistoryIcon from "@mui/icons-material/History";
import HomeOutlinedIcon from "@mui/icons-material/Home";
import AssessmentOutlinedIcon from "@mui/icons-material/Assessment";

export const MenuItems = [
  {
    id: "home",
    title: "Home",
    type: "item",
    icon: <HomeOutlinedIcon />,
    url: "/home",
    permissions: [
      permissions.ViewDashboardStatistics,
      permissions.ViewProductChartsReport,
    ],
  },
  // {
  //   type: "item",
  //   title: "Inbound",
  //   id: "inbound-orders",
  //   url: "/inbound-orders",
  //   icon: process.env.PUBLIC_URL + "/assets/svgs/hovered-warehouse.svg",
  //   permissions: [permissions.InboundView],
  // },
  {
    type: "collapse",
    title: "Inbound",
    id: "inbound-orders",
    url: "/inbound-orders",
    icon: process.env.PUBLIC_URL + "/assets/svgs/hovered-warehouse.svg",
    permissions: [permissions.InboundView],
    children: [
      {
        type: "item",
        title: "Serialized",
        id: "serialized",
        url: "/inbound-orders/serialized",
        icon: process.env.PUBLIC_URL + "/assets/svgs/hovered-warehouse.svg",
        permissions: [permissions.InboundView],
      },
      // {
      //   type: "item",
      //   title: "Non-Serialized",
      //   id: "nonSerialized",
      //   url: "/inbound-orders/nonSerialized",
      //   icon: process.env.PUBLIC_URL + "/assets/svgs/hovered-warehouse.svg",
      //   permissions: [permissions.InboundView],
      // },
    ],
  },
  {
    id: "outbound-orders",
    title: "Outbound",
    type: "item",
    icon: process.env.PUBLIC_URL + "/assets/svgs/hovered-truck.svg",
    url: "/outbound-orders",
    permissions: [permissions.OutboundView],
  },
  {
    id: "area",
    title: "Area",
    type: "item",
    icon: process.env.PUBLIC_URL + "/assets/svgs/hovered-truck.svg",
    url: "/area",
    permissions: [permissions.InboundView],
  },
  {
    id: "verify-status",
    title: "Verify Status",
    type: "item",
    icon: process.env.PUBLIC_URL + "/assets/svgs/hovered-scanner.svg",
    url: "/verify-status",
    permissions: [permissions.Verify_Status],
  },
  // {
  //   id: "serial-generator",
  //   title: "SERIAL GENERATOR",
  //   url: "/serial-generator",
  //   type: "item",
  //   permission: [permissions.UserManagement],  //TODO change it when new permission created
  //   icon: process.env.PUBLIC_URL + "/assets/svgs/qr-hoverd.svg",

  // },
  {
    id: "pack",
    title: "Pack",
    type: "item",
    icon: process.env.PUBLIC_URL + "/assets/svgs/hovered-pack.svg",
    url: "/pack",
    permissions: [permissions.PackView],
  },
  // {
  //   id: "unpack",
  //   title: "Unpack",
  //   type: "item",
  //   icon: process.env.PUBLIC_URL + "/assets/svgs/hovered-unpack.svg",
  //   url: "/unpack",
  //   permissions: [permissions.Disaggregation],
  // },
  {
    id: "products",
    title: "Products",
    type: "item",
    icon: process.env.PUBLIC_URL + "/assets/svgs/hovered-products.svg",
    url: "/products",
    permissions: [permissions.ProductView],
  },

  {
    id: "partners",
    title: "Government Entity",
    type: "item",
    icon: process.env.PUBLIC_URL + "/assets/svgs/hovered-handshake.svg",
    url: "/partners",
    permissions: [permissions.PartnerView],
  },
  {
    id: "decommision",
    title: "Decommission",
    type: "item",
    icon: process.env.PUBLIC_URL + "/assets/svgs/decommission.svg",
    url: "/decommission",
    permissions: [permissions.PartnerView],
  },
  {
    id: "move",
    title: "Move",
    type: "item",
    icon: process.env.PUBLIC_URL + "/assets/svgs/moveOrder.svg",
    url: "/move",
    permissions: [permissions.PartnerView],
  },

  {
    id: "reports",
    title: "Reports",
    type: "collapse",
    icon: <AssessmentOutlinedIcon />,
    permissions: [permissions.ReportView],

    children: [
      {
        id: "activeItems-report",
        title: "Active Inventory",
        type: "item",
        url: "/activeItems-report",
        childLvlTwo: true,
        permissions: [permissions.ActiveNonSerializedItems],
      },
      {
        id: "expiredItems-report",
        title: "Expired Inventory",
        type: "item",
        url: "/expiredItems-report",
        childLvlTwo: true,
        permissions: [permissions.ExpiredNonSerializedItems],
      },
      {
        id: "shippingReport",
        title: "Shipping Report",
        type: "item",
        url: "/shippingReport",
        childLvlTwo: true,
        //TODO : add permission
        // permissions: [permissions.ExpiredNonSerializedItems],
      },
      {
        id: "history-report",
        title: "History",
        type: "collapse",
        icon: <HistoryIcon />,

        permissions: [permissions.AuditTrail],
        children: [
          {
            id: "auditTrail-report",
            title: "Audit Trail",
            type: "item",
            url: "/auditTrail-report",
            childLvlTwo: true,
            permissions: [permissions.AuditTrail],
          },
        ],
      },
    ],
  },
];
